// extracted by mini-css-extract-plugin
module.exports = {"count":"styles-module__count___2pQCU"};